
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/myprofile",
      function () {
        return require("private-next-pages/myprofile/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/myprofile"])
      });
    }
  